import axios from 'shared/lib/axios';

function trackingErrorsPath() {
  return '/v1/tracking_errors';
}

export function postTrackingError({ event, platform }: { event: string; platform: string }) {
  return axios.post<{ success: boolean }>(trackingErrorsPath(), { event, platform });
}
